import { AUTH_ENDPOINT } from "Constants";
import { baseApi } from "Services";
import { resetStoreThunk } from "Utils";

export const authApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    logout: build.mutation<undefined, void>({
      query: () => ({
        url: `${AUTH_ENDPOINT}/logout`,
        method: "POST",
      }),
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(resetStoreThunk());
      },
      invalidatesTags: ["Whoami", "Authentication"],
    }),
  }),
  overrideExisting: false,
});

export const { useLogoutMutation } = authApi;
